import { Injectable, inject } from '@angular/core';
import { catchError, combineLatest, filter, of, switchMap, take, Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { ReportGroupFilterListingService } from 'src/app/services/api/report-group-filter/report-group-filter-listing.service';
import { selectCommodities } from 'src/app/pages/help-and-settings/user-settings/store/user-settings.reducer';
import { Commodity } from '@portal/shared/types/commodity.types';
import {
  HISTORY_DATE_TIME,
  NIC_UPDATE_TYPE_VALUES,
  UPDATE_TYPE
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import {
  FilterModel,
  FilterModels,
  ListingFiltersSource
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { HISTORY_LOG_DEVICE_TYPE } from './history-log-listing.filters';

@Injectable()
export class HistoryLogListingFiltersSourceService implements ListingFiltersSource {
  readonly reportGroupFilterService = inject(ReportGroupFilterListingService);
  readonly #store = inject(Store);

  readonly #applicable = 'AMI Health Dashboard';

  getAll(): Observable<FilterModels> {
    return combineLatest([
      this.reportGroupFilterService.updateFilter(this.#applicable),
      this.#store.select(selectCommodities).pipe(
        filter(commodities => commodities.length > 0),
        take(1)
      )
    ]).pipe(
      switchMap(([_, commodities]) => {
        const hasElectricity = commodities.includes(Commodity.Electricity);
        const updateTypeItems = hasElectricity
          ? UPDATE_TYPE.items
          : UPDATE_TYPE.items.filter(item => !NIC_UPDATE_TYPE_VALUES.includes(item.value as never));
        const updateTypeFilter: FilterModel = { ...UPDATE_TYPE, items: updateTypeItems, selected: updateTypeItems };
        return of([this.reportGroupFilterService.filter, HISTORY_DATE_TIME, updateTypeFilter, HISTORY_LOG_DEVICE_TYPE]);
      }),
      catchError(error => {
        return of(error);
      })
    );
  }

  getReportGroup(): Observable<FilterModel> {
    return this.reportGroupFilterService.getFilter(this.#applicable);
  }
}
